import _defineProperty from "/Users/ronaldzwets/repos/aisukurimu/cardano-nft/cardano-nft-essentials/frontend/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/Users/ronaldzwets/repos/aisukurimu/cardano-nft/cardano-nft-essentials/frontend/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import raf from 'raf';
var MODE;

(function (MODE) {
  MODE[MODE["MODE_TIMEOUT"] = 0] = "MODE_TIMEOUT";
  MODE[MODE["MODE_INTERVAL"] = 1] = "MODE_INTERVAL";
})(MODE || (MODE = {}));

var fnMap = new Map();
var executionSet = new Set();
var rafStarted = false;
var startId = 0;

function getTimeStamp() {
  return new Date().getTime();
}

function executeFn(value) {
  var fn = value.fn,
      args = value.args;
  fn.apply(void 0, _toConsumableArray(args));
}

function runFunction() {
  if (executionSet.size === 0) return;
  executionSet.forEach(executeFn);
  executionSet.clear();
}

var checkTick = function checkTick(currentTimeTick) {
  return function (value, id) {
    var nextTick = value.nextTick,
        ms = value.ms,
        mode = value.mode;

    if (currentTimeTick - nextTick >= 0) {
      executionSet.add(value);

      if (mode === MODE.MODE_TIMEOUT) {
        fnMap.delete(id);
      } else {
        fnMap.set(id, _objectSpread(_objectSpread({}, value), {}, {
          nextTick: nextTick + ms
        }));
      }
    }
  };
};

function loop() {
  if (fnMap.size === 0) {
    rafStarted = false;
    return;
  }

  var currentTimeTick = getTimeStamp();
  fnMap.forEach(checkTick(currentTimeTick));
  runFunction();

  if (fnMap.size === 0) {
    rafStarted = false;
    return;
  }

  raf(loop);
}

function addId(_ref) {
  var fn = _ref.fn,
      ms = _ref.ms,
      args = _ref.args,
      mode = _ref.mode;
  if (!fn) return null;
  var currentId = startId;
  fnMap.set(currentId, {
    fn: fn,
    ms: ms,
    nextTick: getTimeStamp() + ms,
    args: args,
    mode: mode
  });

  if (!rafStarted) {
    rafStarted = true;
    raf(loop);
  }

  startId += 1;
  return currentId;
}

function removeId(id) {
  if (id == null) return;

  if (fnMap.has(id)) {
    fnMap.delete(id);
  }
}

export var setTimeout = function setTimeout(fn) {
  var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return addId({
    fn: fn,
    ms: ms,
    args: args,
    mode: MODE.MODE_TIMEOUT
  });
};
export var clearTimeout = removeId;
export var setInterval = function setInterval(fn) {
  var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  return addId({
    fn: fn,
    ms: ms,
    args: args,
    mode: MODE.MODE_INTERVAL
  });
};
export var clearInterval = removeId;
export default {
  setTimeout: setTimeout,
  clearTimeout: clearTimeout,
  setInterval: setInterval,
  clearInterval: clearInterval
};